import { Link, useParams } from "react-router-dom";
import CatalogPage from "../components/equipment/CatalogPage";
import EquipmentSpecTable from "../components/equipment/EquipmentSpecTable";
import { SHOW_APPLICATION_PAGES } from "../featureFlags";
import { COMPARE_PAIRS } from "../data/catalog";
import { ROBOTS } from "../data/robots";
import { specRows } from "../data/equipmentDisplay";
import NotFound from "./NotFound";

export function compareTitle(leftName, rightName) {
  const clean = (name) => name.replace(/\bAMR\b/g, " ").replace(/\s+/g, " ").trim();
  const leftWords = clean(leftName).split(" ");
  const rightWords = clean(rightName).split(" ");
  let shared = 0;
  while (
    shared < leftWords.length - 1 &&
    shared < rightWords.length - 1 &&
    leftWords[shared] === rightWords[shared]
  ) {
    shared += 1;
  }
  return `${leftWords.join(" ")} vs ${rightWords.slice(shared).join(" ")} | MAG`;
}

export default function EquipmentCompare() {
  const { pair: pairSlug } = useParams();
  const pair = COMPARE_PAIRS.find((item) => item.slug === pairSlug);
  const left = pair ? ROBOTS.find((robot) => robot.slug === pair.left) : null;
  const right = pair ? ROBOTS.find((robot) => robot.slug === pair.right) : null;

  if (!left || !right) return <NotFound />;

  return (
    <CatalogPage
      title={compareTitle(left.displayName, right.displayName)}
      description={`${left.displayName} and ${right.displayName} compared on published payload, size, and navigation.`}
      path={`/catalog/compare/${pair.slug}`}
      noindex={!SHOW_APPLICATION_PAGES}
      h1={`${left.displayName} vs ${right.displayName}`}
    >
      <div className="grid gap-10 lg:grid-cols-2">
        {[left, right].map((robot) => (
          <section key={robot.slug}>
            <h2 className="text-2xl font-semibold">{robot.displayName}</h2>
            <p className="mt-3 text-sm leading-relaxed text-gray-700">{robot.summary}</p>
            <div className="mt-6">
              <EquipmentSpecTable rows={specRows(robot)} />
            </div>
            <p className="mt-4 text-sm">
              <Link to={`/catalog/${robot.slug}`} className="underline">
                {`${robot.displayName} specifications`}
              </Link>
            </p>
          </section>
        ))}
      </div>
    </CatalogPage>
  );
}
